import React from "react";
import * as _ from "lodash";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import style from "./style";
import classnames from "classnames";

// Create styles
const useStyles = makeStyles(() => createStyles(style()));

// Props type
type props = {
  errorMessage: string;
  note: string;
};

// UIErrorOrNoteMessage Component
export const UIErrorOrNoteMessage = (props: props): React.JSX.Element => {
  const { errorMessage,
     note 
    } = props;
  const classes = useStyles();

  if (_.isEqual(errorMessage.length, 0)) {
    return (
      <div
      dangerouslySetInnerHTML={{
        __html: note,
      }}
        className={classnames(classes.note, {
          [classes.noteErrorMargin]: !_.isEmpty(note),
        })}
       
      ></div>
    );
  }
  return (
    <div
      className={classnames(classes.error, {
        [classes.noteErrorMargin]: !_.isEmpty(errorMessage),
      })}
    >
      {errorMessage}
    </div>
  );
};
